<script>

import Layout from "../../layouts/main";
import PageHeader from "../../components/page-header";
import config from "../../config";
import pagination from "laravel-vue-pagination";
import { productService } from "../../services";
import { vendorService } from "../../services";
import { required } from "vuelidate/lib/validators";
import DropzonePopup from "../../components/widgets/dropzone-popup";
import draggable from "vuedraggable";
import { debounce,success_message,error_message } from "../../Helper/helper";
import { columnCancelOrderDataChart } from "../data-apex";

export default {
  components: { Layout, PageHeader, pagination, productService, DropzonePopup, draggable },
    data() {
        const { status,menu_id,orderBy,sortBy} = this.$route.query;
        return {
            importModal: false,
            importNumbersModal: false,
            import_file : '',
            import_numbers_file : '',
            import_image_zip: '',
            title: this.trans.get('__JSON__.Products'),
            url: null,
            debounce: false,
            items: [],
            categories: [],
            subCategories: [],
            checked: true,
            sortBy: sortBy || "reorder",
            sortDesc: orderBy && orderBy != '' ? true : orderBy,
            loading: true,
            paginations: {},
            limit: 1,
            search: "",
            status: status == undefined ? '1' :status,
            config: config,
            category_id: "",
            menu_id: "",
            productCount: "",
            product_image: "",
            searchData:debounce(()=>{
                if(!this.init){
                    const {status,menu_id,orderBy,sortBy} = this.$data;
                    this.$router.replace({name: 'product-list', query: {status,menu_id,orderBy,sortBy}})
                }
                this.saveFilterValues();
                this.getProduct();
                this.init = false;
            },500),
            
            fields: [
                // { key: "images", label: "#", sortable: false },
                { key: "category_name", label: "Category", sortable: true },
                { key: "menu_name", label: "Sub Category", sortable: true },
                { key: "item_name_lang", label: "Name", sortable: true },
                { key: "vat", label: "Tax", sortable: true },
                { key: "status", label: "Status", sortable: false ,thClass:"dis-event"},
                { key: "action", label: "Action", sortable: false,thClass:"dis-event" },
            ],
        };
    },
    mounted() {
        
        const savedFilters = JSON.parse(localStorage.getItem('productFilters'));
        if (savedFilters) {
            this.category_id = savedFilters.category_id || '';
            this.menu_id = savedFilters.menu_id || '';
            this.status = savedFilters.status || '';
            this.sortBy = savedFilters.sortBy || 'reorder'; // Default sorting value
            this.sortDesc = savedFilters.sortDesc || false; // Default sorting order
            this.search = savedFilters.search || '';
        }
        // Fetch products using retrieved filter values
        this.getProduct();
        this.getMainCategory();
        // Set subcategory based on the retrieved category_id
        if (this.category_id) {
            this.getSubCategory({ target: { value: this.category_id } });
        }
    },
    validations: {
        import_file: {
            required,
        },
        import_numbers_file: {
            required,
        },
       
    },
    destroyed() {
        if (this.$route.name !== 'product-list' && this.$route.name !== 'sub-product-list' && this.$route.name !== 'product-edit') {
            localStorage.removeItem('productFilters');
        }
    },
    methods: {
        Uploadfile(){
            this.importModal = true;
            this.clearCsv();
        },
        Uploadnumbersfile(){
            this.importNumbersModal = true;
            this.clearNumberCsv();
        },
        clearCsv(){
            this.import_file = '';
            this.import_image_zip = '';
            this.$v.$reset();
        },
        closeCsv(){
            this.importModal=false;
            this.clearCsv();
        },
        clearNumberCsv(){
            this.import_numbers_file = '';
            this.$v.$reset();
        },
        closeNumberCsv(){
            this.importNumbersModal=false;
            this.clearCsv();
        },
        importMenuItem(e){
            
            this.$v.import_file.$touch();
            if (this.$v.import_file.$invalid) {
                return;
            } else {
                vendorService.importMenuItem({import_file:this.import_file,import_image_zip: this.import_image_zip,restaurant_id :this.$route.params.restaurant_id})
                .then(response => {
                if (response.data.code === 200) {
                    this.importModal = false;
                    this.getProduct();
                    success_message(response.data.message);
                    this.clearCsv();
                } else {
                    error_message(response.data.message);
                }
                });
            }
        },
        importProductNumber(e){
            this.$v.import_numbers_file.$touch();
            if (this.$v.import_numbers_file.$invalid) {
                return;
            } else {
                vendorService.importProductNumber({import_numbers_file:this.import_numbers_file})
                .then(response => {
                if (response.data.code === 200) {
                    this.importNumbersModal = false;
                    this.getProduct();
                    success_message(response.data.message);
                    this.clearCsv();
                } else {
                    error_message(response.data.message);
                }
                });
            }
        },
        getMainCategory(){
            productService
            .getMainCategory()
            .then((response) => {
                // this.categories = response.data.result;
                this.categories = response.data.result.sort((a, b) => {
                    return a.category_name.localeCompare(b.category_name);
                });
            });
        },
        getSubCategory(event){
            if (this.$route.name !== 'product-list') {
                this.$router.replace({name: 'product-list'});
            }
            const savedFilters = JSON.parse(localStorage.getItem('productFilters'));
            if(savedFilters && (event.target.value  != savedFilters.category_id)){
                this.menu_id = '';
            }
            this.category_id = event.target.value;
            
            productService
            .getSubCategory({category_id : this.category_id})
            .then((response) => {
                // this.subCategories = response.data.result;
                this.subCategories = response.data.result.sort((a, b) => {
                    return a.menu_name.localeCompare(b.menu_name);
                });
            });
            this.getProduct();
        },
        sortingChanged(ctx) {
            this.sortBy = ctx.sortBy;
            this.sortDesc = ctx.sortDesc;
            this.saveFilterValues();
            this.getProduct();
        },
        getProduct(page) {
            this.loading = true;
            productService
            .getProduct({ 
                search: this.search,
                status: this.status,
                menu_id: this.menu_id,
                category_id: this.category_id,
                sortBy: this.sortBy,
                orderBy: this.sortDesc ? "desc" : "asc",
                page: page && page > 0 ? page : 1,
            })
            .then((response) => {
                this.loading = false;
                this.paginations = response.data.result;
                this.items = response.data.result.data;
                this.productCount = response.data.result.data.length;
            });
        },
        deleteProduct(id){
            if(confirm("Do you really want to delete?")){
                productService.deleteProduct({id:id})
                .then(response => {
                    if (response.data.code === 200) {
                        this.getProduct();
                        success_message(response.data.message);
                    } else {
                        error_message(response.data.message);
                    }
                });
            }
        },
        saveFilterValues() {
            if (this.$route.name === 'product-list' || this.$route.name === 'sub-product-list' || this.$route.name === 'product-edit') {
                localStorage.setItem('productFilters', JSON.stringify({
                    category_id: this.category_id,
                    menu_id: this.menu_id,
                    status: this.status,
                    sortBy: this.sortBy,
                    sortDesc: this.sortDesc,
                    search: this.search
                }));
            }else{
                localStorage.removeItem('productFilters');
            }
        },
    },
};
</script>
<template>
    <div>
        <div class="row">
            <div class="col-12">
                <div class="page-title-box d-flex align-items-center justify-content-between icon-main-page" >
                    <div class="page-title-left">
                        <div class="avatar-xs mr-3">
                        <span class="avatar-title rounded-circle bg-soft-primary text-primary font-size-18">
                            <i class="bx bx-user-circle"></i>
                        </span>
                        </div>
                        <h4 class="mb-0 font-size-18">{{ trans.get('__JSON__.Products') }}({{productCount}})</h4>
                    </div>
                    <div class="page-title-right d-flex">
                        <!-- <button @click="Uploadnumbersfile()" class="btn btn-success btn-rounded mr-2 add-btn">
                            {{ trans.get('__JSON__.Import Products Numbers') }}
                        </button> -->
                        <button @click="Uploadfile()" class="btn btn-success btn-rounded mr-2 add-btn">
                            {{ trans.get('__JSON__.Import Products') }}
                        </button>
                        <router-link :to="{name: 'product-add'}" class="btn btn-success btn-rounded mr-2 add-btn">
                            <i class="mdi mdi-plus mr-1"></i>
                            {{ trans.get('__JSON__.Add Product') }}
                        </router-link>
                    </div>
                </div>
            </div>
        </div>
        <div class="row list-table-main">
            <div class="col-12">
                <div class="card">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-sm-2 offset-sm-4">
                                <div class="form-group">
                                    <div class="date-range-list">
                                        <label>{{ trans.get('__JSON__.Category') }} :</label>
                                        <select class="custom-select" v-model="category_id" @change="getSubCategory($event)">
                                            <option value="" selected>{{ trans.get('__JSON__.All') }}</option>
                                            <option v-for="cat in categories" :value="cat.category_id" :key="cat.category_id">{{cat.category_name}}</option>
                                        </select>
                                    </div>
                                </div>
                            </div>

                            <div class="col-sm-2">
                                <div class="form-group">
                                    <div class="date-range-list">
                                        <label>{{ trans.get('__JSON__.Sub Category') }} :</label>
                                        <select class="custom-select" v-model="menu_id" @change="searchData()">
                                            <option value="" selected>{{ trans.get('__JSON__.All') }}</option>
                                            <option v-for="sub in subCategories" :value="sub.id" :key="sub.id">{{sub.menu_name}}</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                            
                            <div class="col-sm-2">
                                <div class="form-group">
                                    <div class="date-range-list">
                                        <label>{{ trans.get('__JSON__.Status') }} :</label>
                                        <select class="custom-select" v-model="status" @change="searchData()">
                                            <option value="">{{ trans.get('__JSON__.All') }}</option>
                                            <option value="1" selected>{{ trans.get('__JSON__.Active') }}</option>
                                            <option value="0">{{ trans.get('__JSON__.Inactive') }}</option>
                                        </select>
                                    </div>
                                </div>
                            </div>

                            <div class="col-sm-2">
                                <div class="date-range-list">
                                    <label>{{ trans.get('__JSON__.Search') }} :</label>
                                    <div class="text-sm-right">
                                        <div class="search-box mr-2 d-inline-block">
                                            <div class="position-relative">
                                                <input
                                                type="text"
                                                class="form-control"
                                                id="search"
                                                @input="searchData()"
                                                v-model="search"
                                                :placeholder="trans.get('__JSON__.Search Placeholder')"
                                                />
                                                <i class="bx bx-search-alt search-icon"></i>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12 table-main-list product-table table-responsive">
                                <b-table
                                :items="items"
                                :fields="fields"
                                :sort-by.sync="sortBy"
                                :sort-desc.sync="sortDesc"
                                :no-local-sorting="true"
                                @sort-changed="sortingChanged"
                                :busy="loading"
                                show-empty
                                >
                                <template #table-busy>
                                    <div class="text-center text-danger my-2">
                                    <b-spinner class="align-middle"></b-spinner>
                                    <strong>{{trans.get('__JSON__.Loading...')}}</strong>
                                    </div>
                                </template>

                                <template v-slot:cell(category_name)="data">
                                    <h5 class="font-size-14">{{ data.item.category_name }}</h5>
                                </template>

                                <template v-slot:cell(menu_name)="data">
                                    <h5 class="font-size-14">{{ data.item.menu_name }}</h5>
                                </template>

                                <template v-slot:cell(item_name_lang)="data">
                                    <h5 class="font-size-14">{{ data.item.item_name_lang }}</h5>
                                </template>

                                <template v-slot:cell(vat)="data">
                                    <span>{{ data.item.vat }}</span>
                                </template>

                                <template v-slot:cell(status)="data">
                                    <div
                                    v-if="data.item.status == '0'"
                                    class="badge badge-pill badge-soft-danger font-size-12"
                                    >{{ trans.get('__JSON__.Inactive') }}</div>
                                    <div
                                    v-else
                                    class="badge badge-pill badge-soft-success font-size-12"
                                    >{{ trans.get('__JSON__.Active') }}</div>
                                    
                                </template>

                                <template v-slot:cell(action)="data">
                                    <router-link
                                    :to="{name: 'product-edit',params: { id:base64(data.item.id)}}"
                                    class="btn btn-success btn-sm btn-rounded"
                                    >Edit</router-link>

                                    <router-link
                                    :to="{name: 'sub-product-list',params: { product_id:base64(data.item.id)}}"
                                    class="btn btn-primary btn-sm btn-rounded"
                                    >Sub Product</router-link>

                                    <button
                                        type="submit"
                                        @click="deleteProduct(base64(data.item.id))"
                                        class="btn btn-danger btn-sm btn-rounded ml-1"
                                    >{{ trans.get('__JSON__.Delete') }}</button>
                                </template>

                                <template #empty>
                                    <p class="text-center">{{ trans.get('__JSON__.No Product Found') }}</p>
                                </template>
                                </b-table>
                            </div>
                            <div class="row col-sm-5 offset-sm-7">
                                <div class="col">
                                <div class="dataTables_paginate paging_simple_numbers float-right">
                                    <ul class="pagination pagination-rounded mb-0">
                                    <!-- pagination -->
                                        <pagination
                                            :data="paginations"
                                            :limit="limit"
                                            @pagination-change-page="getProduct"
                                        ></pagination>
                                    </ul>
                                </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <b-modal v-if="$auth.hasPermission(config.permissions.merchant_write)" v-model="importModal" scrollable :title="trans.get('__JSON__.Import Products & Sub-products')" title-class="font-18" centered>
        <form @submit.prevent="importMenuItem">
          <div class="row">
            <h5 class="download">{{trans.get('__JSON__.To Upload Products & Sub-Products, Download Sample File')}} <a :href="config.appurl+'public/sample-csv/Product-Upload.csv'" download> {{ trans.get('__JSON__.from Here') }} </a></h5>
            <div class="col-sm-6">
                <div class="form-group">
                  <label>{{ trans.get('__JSON__.Upload .csv file') }}</label>
                  <dropzone-popup v-model="import_file" id="import_file" name="import_file" acceptedFiles=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel" :class="{ 'is-invalid': $v.import_file.$error }"/>
                  <div v-if="$v.import_file.$error" class="invalid-feedback cuisine-img">
                    <span
                      v-if="!$v.import_file.required"
                    >{{ trans.get('__JSON__.Please select file') }}.</span>
                  </div>
                </div>
            </div>

            <div class="col-sm-6 mb-5">
                <div class="form-group">
                  <label >{{ trans.get('__JSON__.Upload ZIP file of item images (Optional)') }}</label>
                  <dropzone-popup v-model="import_image_zip" id="import_image_zip" name="import_image_zip" acceptedFiles=".zip"/>
                 
                </div>
            </div>
          </div>
          <input type="hidden" name="restaurant_menu_item_id" value="menu_item.restaurant_menu_id">
        </form>
        <template slot="modal-footer">
          <div class="w-100">
            <b-button variant="primary"  class="float-right"  @click="importMenuItem($event)">{{ trans.get('__JSON__.Upload') }}</b-button>
            <b-button class="float-left" @click="closeCsv">{{ trans.get('__JSON__.Close') }}</b-button>
          </div>
        </template>
        </b-modal>
        
        <!-- Product Number Modal -->
        <b-modal v-if="$auth.hasPermission(config.permissions.merchant_write)" v-model="importNumbersModal" scrollable :title="trans.get('__JSON__.Import Old & New Products Numbers')" title-class="font-18" centered>
            <form @submit.prevent="importProductNumber">
                <div class="row">
                    <h5 class="download">{{trans.get('__JSON__.To Upload Old & New Products Numbers, Download Sample File')}} <a :href="config.appurl+'public/sample-csv/Product-Upload.csv'" download> {{ trans.get('__JSON__.from Here') }} </a></h5>
                    <div class="col-lg-12">
                        <div class="form-group">
                            <label>{{ trans.get('__JSON__.Upload .csv file') }}</label>
                            <dropzone-popup v-model="import_numbers_file" id="import_numbers_file" name="import_numbers_file" acceptedFiles=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel" :class="{ 'is-invalid': $v.import_numbers_file.$error }"/>
                            <div v-if="$v.import_numbers_file.$error" class="invalid-feedback cuisine-img">
                                <span
                                    v-if="!$v.import_numbers_file.required"
                                >{{ trans.get('__JSON__.Please select file') }}.</span>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
            <template slot="modal-footer">
            <div class="w-100">
                <b-button variant="primary"  class="float-right"  @click="importProductNumber($event)">{{ trans.get('__JSON__.Upload') }}</b-button>
                <b-button class="float-left" @click="closeNumberCsv">{{ trans.get('__JSON__.Close') }}</b-button>
            </div>
            </template>
        </b-modal>
    </div>
</template>